import * as React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import CheckoutAdditionalService from '../..';
import { useTheme } from '../../../theme';
import Modal from '../../../Modal';
import { getBusinessLounge, getSegments, getTravellers } from '../../../Checkout/store/order/selectors';
import { useIsMobile } from '../../../utils';
import { useOrderService } from '../hooks';
import { getCalculatedBusinessLoungePrice } from '../../../Checkout/store/orderPrice/selectors';
import { useRenderers } from '../../../renderProps';
import ServiceError from '../ServiceError/ServiceError';
import VipServiceSelect from '../../../VipServiceSelect';
import Control from '../../../VipServiceSelect/components/Control/Control';
import Money from '../../../Money';
import Close from '../Close/Close';
import BusinessSummary from '../../../ServiceSummary/services/BusinessSummary';
var Business = function () {
    var _a;
    var theme = useTheme('CheckoutAdditionalService').Business;
    var t = useTranslation('Checkout').t;
    var travellers = useSelector(getTravellers);
    var segments = useSelector(getSegments);
    var businessLoungeServices = useSelector(getBusinessLounge);
    var price = useSelector(getCalculatedBusinessLoungePrice);
    var _b = useOrderService(businessLoungeServices, OrderAdditionalServiceGdsServiceServiceType.BusinessLounge), isSelected = _b.isSelected, selectedServices = _b.selectedServices, unconfirmedServices = _b.unconfirmedServices, renderSubheader = _b.renderSubheader, onOpen = _b.onOpen, onClose = _b.onClose, setOpened = _b.setOpened, onSaveHandler = _b.onSaveHandler, onRemoveHandler = _b.onRemoveHandler, passengers = _b.passengers, opened = _b.opened;
    if (!businessLoungeServices.length) {
        return null;
    }
    var isMobile = useIsMobile();
    var renderClose = function (onClick) { return React.createElement(Close, { onClick: onClick }); };
    var renderPassenger = function (_a) {
        var _b;
        var passenger = _a.passenger, type = _a.type, count = _a.count, isConfirmed = _a.isConfirmed, onSetCount = _a.onSetCount;
        var price = (_b = businessLoungeServices.find(function (service) { return service.id === passenger.serviceId; })) === null || _b === void 0 ? void 0 : _b.price;
        return (React.createElement("div", { className: theme.passenger },
            React.createElement(Control, { type: type, count: count, label: React.createElement("div", { className: theme.label }, passenger.name), disabled: isConfirmed, onSetCount: onSetCount(passenger) }),
            React.createElement("div", { className: theme.price }, count > 0 && React.createElement(Money, { money: price }))));
    };
    var CustomCheckoutAdditionalService = useRenderers().CheckoutAdditionalService;
    var ServiceWrapper = (_a = CustomCheckoutAdditionalService === null || CustomCheckoutAdditionalService === void 0 ? void 0 : CustomCheckoutAdditionalService.CheckoutAdditionalService) !== null && _a !== void 0 ? _a : CheckoutAdditionalService;
    var buttons = useMemo(function () {
        if (unconfirmedServices.length) {
            return [
                {
                    className: theme.button__remove,
                    action: function () { return onRemoveHandler(unconfirmedServices); },
                    text: t('Remove'),
                    buttonType: 'change',
                    variant: 'outline'
                }
            ];
        }
        return [
            {
                action: function () { return setOpened(true); },
                text: t('Change'),
                buttonType: 'change'
            }
        ];
    }, [unconfirmedServices]);
    var onServiceDelete = function (_, payload) {
        var servicePayload = payload;
        onRemoveHandler([
            {
                serviceId: servicePayload.serviceId,
                passengerId: servicePayload.passengerId,
                segmentIds: [servicePayload.segmentId],
                count: 0
            }
        ]);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(BusinessSummary, { travellers: travellers, services: businessLoungeServices, onServiceDelete: onServiceDelete }, function (content) { return (React.createElement(ServiceWrapper, { header: t('Business lounge'), description: businessLoungeServices[0].description, className: theme.business, priceFrom: isSelected ? price : null, priceTotal: price, isSelected: isSelected, addClick: onOpen, descriptionClassName: theme.descriptions, buttons: buttons },
            React.createElement(ServiceError, { isShow: !!unconfirmedServices.length }, content))); }),
        React.createElement(Modal, { open: opened, classes: {
                scrollBody: theme.scrollBody,
                paper: theme.paper
            }, slideUp: isMobile, maxWidth: "sm", closeButtonRenderer: renderClose, onClose: onClose },
            React.createElement(VipServiceSelect, { header: t('Business lounge'), headerClassName: theme.header, className: theme.serviceSelect, subheader: renderSubheader(), passengers: passengers, services: businessLoungeServices, segments: segments, selectedServices: selectedServices, type: "checkbox", onSave: onSaveHandler, onClose: onClose, renderPassenger: renderPassenger, showSegmentLabel: false, showTotalPrice: true, showFromPrice: true }))));
};
export default Business;
